<template>
  <div class="page-box">
    <!-- <div class="page-title">
      <div>批量导入</div>
      <el-link type="primary" href="/#/copyrightExport?type=1">新建批量导入</el-link>
    </div> -->
    <div class="page-main"> 
      <el-table :data="tableData" style="width: 100%" :header-cell-style="{
      background: '#F5F7FA',
      color: '#303133',
      fontWeight: '800',
    }">
      <!-- <el-table-column label="导入时间" prop="name"></el-table-column>
      <el-table-column label="导入状态"></el-table-column>
      <el-table-column label="预计导入数量"></el-table-column>
      <el-table-column label="实际导入数量"></el-table-column>
      <el-table-column label="失败数量"></el-table-column>
      <el-table-column label="发表状态"></el-table-column> -->
      <el-table-column label="文章标题">
          <template #default="scope">
            <div>
              {{ scope.row.name || "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="uniqueCode" label="哈希值" />
        <el-table-column label="创建时间">
          <template #default="scope">
            <div>
              {{ scope.row.createTime || "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="龙源证书发布时间" v-if="typeValue != 0 && typeValue != 1">
          <template #default="scope">
            <div>
              {{ scope.row.lyUplinkPushTime || "-" }}
            </div>
          </template>
        </el-table-column>
        
        <el-table-column label="龙源证书状态">
          <template #default="scope">
            <div v-if="scope.row.uplinkType == 1 || scope.row.uplinkType == 3">
              <span>{{ scope.row.lyUplinkStatus == 0 ? '草稿箱' : scope.row.lyUplinkStatus == 1 ? '审核中' :
                  scope.row.lyUplinkStatus == 2 ? '已发布' : scope.row.lyUplinkStatus == 3 ? '审核失败' :
                    scope.row.lyUplinkStatus
              }}</span>
            </div>
            <div v-else>
              -
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template #default="scope">
            <div>
              企业付费
            </div>
          </template>
        </el-table-column>

      <el-table-column label="操作" width="120px">
        <template #default="scope">
          <div>
            <router-link :to="`/articleDetails?uniqueCode=${scope.row.contentUplinkCode}`">
              <el-link type="primary" class="mr-10" @click="toView(scope.row)">查看详情</el-link>
            </router-link>
            <!-- <el-link class="mr-10">刷新</el-link> -->
            <!-- <el-link>下载失败报表</el-link> -->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <pagingComponent @handleCurrentChangeSub="noChangePagination" :currentPage="totalnum.page" :rows="totalnum.pageSize" :total="totalnum.total" />


    </div>


  </div>

</template>

<script setup>
import { ref, provide, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import pagingComponent from "@/components/pagingComponent/index";
import { importRecord } from '@/api/interfaceList'
import Cookies from 'js-cookie'
const tableData = ref([])

const totalnum = ref({
  page: 1,
  pageSize: 10,
  total: 20
})

const route = useRoute();

const getList = ()  => {
  importRecord({
      userCode: JSON.parse(Cookies.get("userInformation")).userCode,
      page: totalnum.value.page,
      pageSize: totalnum.value.pageSize,
      importBatchNo: route.query.importBatchNo
    }).then((res) => {
      // res.data.records.map(item => {
      //   if (item.uplinkType == 3) {
      //     item.uplinkStatus == 0 || item.uplinkStatus == 3 || item.lyUplinkStatus == 0 || item.lyUplinkStatus == 3 ? item.isSetting = true : item.isSetting = false
      //   } else if(item.uplinkType == 1){
      //     item.lyUplinkStatus == 0 || item.lyUplinkStatus == 3 ? item.isSetting = true : item.isSetting = false
      //   }else if(item.uplinkType == 2){
      //     item.uplinkStatus == 0 || item.uplinkStatus == 3 ? item.isSetting = true : item.isSetting = false
      //   }
      // })
      totalnum.value.total = res.data.pages;
      tableData.value = res.data.records;
    });
}


onMounted(() => {
  getList()
})
const noChangePagination = (res) => {
  totalnum.value.page = res;
  getList();
}
</script>
<style scoped>

.page-box{
  background: #fff;
  border-radius: 10px;
  padding:10px 20px;
}

.page-main{
  /* padding: 10px; */
}

.page-title{
  display: flex;
  height: 64px;
  /* line-height: 64px; */
  box-shadow: inset 0px 0px 0px 0px rgba(0,0,0,0.1);
  justify-content: space-between;
  align-items:center;
}
</style>
